import {IconButton} from "@mui/material";
import {useEffect} from "react";
import {FiTrash2} from "react-icons/fi";
import {tokenColumns} from "../../constants/dataGridColumns";
import ListView from "../ListView/ListView";
import useApiRequest from "../../hooks/useApiRequest";

const UserTokensGrid = ({userId}) => {
  const {data, loading, list} = useApiRequest(`/tokens?userId=${userId}`);
  const {remove} = useApiRequest("/tokens");

  useEffect(() => {
    list();
    // eslint-disable-next-line
  }, []);

  const handleRowDelete = async (id) => {
    try {
      await remove(id);
      list();
    } catch (error) {
      console.error("Error al eliminar el registro:", error);
    }
  };

  const columns = [
    ...tokenColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="secondary"
            onClick={(e) => {
              e.stopPropagation();
              handleRowDelete(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return <ListView viewTitle={"Tokens"} columns={columns} data={data?.data || []} loading={loading} />;
};

export default UserTokensGrid;
